import axios from "../axiosInstance";
import { GetEmployeesWithResourceShareStatusResponse } from "./types";

export const getEmployeesWithResourceShareStatus = async (
  resourceUuid: string,
): Promise<GetEmployeesWithResourceShareStatusResponse> => {
  const response = await axios.get<GetEmployeesWithResourceShareStatusResponse>(
    `/api/private/resources/${resourceUuid}/employees/share-status`,
  );
  return response.data;
};
